import { Pipe } from '@angular/core';
import { Record as AppRecord } from 'src/app/models/record';
import { Util } from 'src/app/util';
import { CardItemLink } from '../../components/card-item/card-item.interface';
import type { RecordSearch } from 'src/app/search/service/records-search/models/record-search.model';

@Pipe({
  name: 'infoUrl',
})
export class InfoUrlPipe {
  transform(
    record: AppRecord | RecordSearch,
    extraParams?: Record<string, string | undefined>,
    state?: Record<string, unknown>
  ): CardItemLink {
    const queryParams = this.buildQueryParams(extraParams);
    let slug = Util.slugifyRecord(record);
    let path = `/info/${slug}`;

    if (this.isAppRecord(record) && record.wishListInfo.id) {
      slug = Util.slugifyList(record.title, record.wishListInfo.id);
      path = `/list/${slug}`;
    }

    if (this.isRecordSearch(record) && record.additionalData?.elementWishListId) {
      slug = Util.slugifyList(record.title, record.additionalData.elementWishListId);
      path = `/list/${slug}`;
    }

    return {
      path,
      queryParams,
      // Returns an empty object if state is undefined to ensure
      // destination pages can reliably check for state to toggle "Go Back" buttons
      state: state ?? {},
    };
  }

  private buildQueryParams(extraParams: Record<string, string>) {
    if (!extraParams || Object.values(extraParams).every((v) => v === undefined)) {
      return undefined;
    }

    return Object.entries(extraParams).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }

  private isAppRecord(record: AppRecord | RecordSearch): record is AppRecord {
    return 'wishListInfo' in record;
  }

  private isRecordSearch(record: AppRecord | RecordSearch): record is RecordSearch {
    return 'additionalData' in record;
  }
}
